import { knowledgeBaseConstants } from '@constants/knowledge-base';
import { knowledgeBaseService } from '@services';

const get = (params, page = 0, pageSize = 10) => {
    return dispatch => {
        dispatch(request());
        knowledgeBaseService.getKnowledgeBase(params, page, pageSize).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

function request() {
    return { type: knowledgeBaseConstants.KNOWLEDGE_BASE_REQUEST };
}

function success(data) {
    return { type: knowledgeBaseConstants.KNOWLEDGE_BASE_SUCCESS, data };
}

function failure() {
    return { type: knowledgeBaseConstants.KNOWLEDGE_BASE_FAILURE };
}

export const knowledgeBaseActions = {
    get,
};
